// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UsersStudents_wrapper","is-current-cohort":"UsersStudents_is-current-cohort","isCurrentCohort":"UsersStudents_is-current-cohort"};